import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import { colors } from '../../../shared/styles';

const StyledNumericInput = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .input-wrapper {
        display: flex;
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
    }

    & .prefix {
        box-sizing: border-box;
        font-size: 14px;
        padding: 6px 10px;
        border-right: solid 1px ${colors.offWhite};
        white-space: nowrap;
    }

    & .suffix {
        box-sizing: border-box;
        font-size: 14px;
        padding: 6px 10px;
        border-left: solid 1px ${colors.offWhite};
        white-space: nowrap;
    }

    & input {
        width: 100%;
        box-sizing: border-box;
        padding: 6px 10px;
        font-size: 14px;
        border-radius: 4px;
        border: none;
    }

    & input[disabled] {
        background: ${colors.offWhiteLighter};
    }

    &.input-error {
        & label {
            color: ${colors.error.default};
        }

        & .input-wrapper {
            border-color: ${colors.error.default};
        }

        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }
`;

type NumericInputProps = {
    disabled?: boolean,
    input: any,
    label: string,
    min?: number,
    max?: number,
    prefix?: string,
    suffix?: string,
    meta?: object,
    step?: number,
};

const NumericInput = (props: NumericInputProps) => {
    const {
        disabled,
        input,
        label,
        min,
        max,
        prefix,
        suffix,
        meta: { touched, error, submitFailed } = {},
        step,
    } = props;

    const id = shortid.generate();

    let wrapperClass = 'input-wrapper';

    if (prefix && suffix) {
        wrapperClass = `${wrapperClass} ${wrapperClass}__prefix-suffix`;
    } else if (prefix) {
        wrapperClass = `${wrapperClass} ${wrapperClass}__prefix`;
    } else if (suffix) {
        wrapperClass = `${wrapperClass} ${wrapperClass}__suffix`;
    }

    const showError = (touched || submitFailed) && error;
    const errorClass = showError ? 'input-error' : '';

    return (
        <StyledNumericInput className={errorClass}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <div className={wrapperClass}>
                {prefix &&
                    <div className="prefix">
                        {prefix}
                    </div>}
                <input
                    {...input}
                    disabled={disabled}
                    type="number"
                    id={id}
                    min={min}
                    max={max}
                    step={step || 1}
                />
                {suffix &&
                    <div className="suffix">
                        {suffix}
                    </div>}
            </div>
            {showError &&
                <span>
                    {error}
                </span>}
        </StyledNumericInput>
    );
};

export default NumericInput;



// WEBPACK FOOTER //
// ./src/components/shared/forms/NumericInput.js